import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useParams, useNavigate } from "react-router-dom";
import { AiOutlineShoppingCart, AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import { BsStarFill, BsStarHalf, BsStar, BsStars } from "react-icons/bs";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { PulseLoader } from "react-spinners";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { motion, AnimatePresence } from "framer-motion";
import Header from "../../Page/Header/Header";
import ProductsLayout from "./ProductsLayout";
import fallbackImage from "../../assets/brand-default.jpg";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../Components/Footer/Footer";
import { 
  fetchWishlist,
  addItemToWishlist,
  removeItemFromWishlist
} from "../../redux/thunks/wishlistThunks";
import { updateItemQuantity, addToCart, fetchCart } from "../../redux/thunks/cartThunks";
import { globalLogout } from "../../Utils/Logout";
// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      when: "beforeChildren"
    }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 10
    }
  },
  hover: {
    y: -5,
    scale: 1.02,
    transition: {
      duration: 0.2
    }
  }
};

const buttonVariants = {
  hover: {
    scale: 1.05,
    boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
    transition: {
      duration: 0.3,
      yoyo: Infinity
    }
  },
  tap: {
    scale: 0.95
  }
};

const modalVariants = {
  hidden: {
    opacity: 0,
    scale: 0.8,
    transition: {
      duration: 0.3
    }
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.3
    }
  }
};

const backdropVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
};

const heartBeatVariants = {
  initial: { scale: 1 },
  animate: {
    scale: [1, 1.3, 1],
    transition: {
      duration: 0.5
    }
  }
};

// Helper to get unique values for filters
const getUnique = (arr, key) =>
  [...new Set(
    arr
      .map((item) => {
        if (key === "brand") return item.brand?.name;
        if (key === "price") return item.variants?.map((v) => v.price);
        if (key === "ratings") return Math.floor(item.averageRating || 0);
        return null;
      })
      .flat()
      .filter(Boolean)
  )];

// Price ranges generator
const getPriceRanges = (prices) => {
  if (!prices.length) return [];
  const sorted = [...prices].sort((a, b) => a - b);
  const min = sorted[0];
  const max = sorted[sorted.length - 1];
  if (min === max) return [{ label: `₹${min}`, min, max }];
  const step = Math.ceil((max - min) / 4);
  let ranges = [];
  let start = min;
  for (let i = 0; i < 4; i++) {
    let end = i === 3 ? max : start + step - 1;
    ranges.push({
      label: `₹${start} - ₹${end}`,
      min: start,
      max: end,
    });
    start = end + 1;
  }
  return ranges;
};

const ProductsBySubCategory = () => {
  const { categoryId } = useParams();
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [category, setCategory] = useState("Products");
  const [loading, setLoading] = useState(false);
  const [sortOption, setSortOption] = useState("featured");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(12);
  const [loadingWishlistItems, setLoadingWishlistItems] = useState({});
  const [loadingCartItems, setLoadingCartItems] = useState({});
  const [imageErrors, setImageErrors] = useState({});
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [productToAdd, setProductToAdd] = useState(null);
  const [wishlistAnimation, setWishlistAnimation] = useState(null);
  const [allCategories, setAllCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(categoryId);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = Cookies.get("ecom_user_token");
  const { items: wishlist, loading: wishlistLoading } = useSelector(state => state.wishlist);
  const cartItems = useSelector(state => state.cart.items);

  
useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/seller/category/list`
      );
      setAllCategories(res.data.categories);
    } catch (error) {
      // console.error("Failed to fetch categories:", error);
      // toast.error("Failed to load categories");
      globalLogout(error)
    }
  };
  fetchCategories();
}, []);

// Extract subcategories based on current category
// useEffect(() => {
//   if (!allCategories.length || !categoryId) return;

// const findSubcategories = (categories, parentId) => {
//   let result = [];
  
//   for (const category of categories) {
//     // If we find the parent category
//     if (category.id === parentId) {
//       // Add all direct subcategories
//       result = [...category.subcategories];
      
//       // For each subcategory, recursively add all its subcategories
//       category.subcategories.forEach(subcat => {
//         result = [...result, ...findSubcategories([subcat], subcat.id)];
//       });
//       return result;
//     }
    
//     // If not found at this level, search in subcategories
//     if (category.subcategories && category.subcategories.length > 0) {
//       const found = findSubcategories(category.subcategories, parentId);
//       if (found.length) {
//         result = [...result, ...found];
//         return result;
//       }
//     }
//   }
  
//   return result;
// };

//   const foundSubcategories = findSubcategories(allCategories, categoryId);
  
//   // Filter out duplicates and unpublished categories
//   const uniqueSubcategories = foundSubcategories.filter(
//     (item, index, self) =>
//       index === self.findIndex(t => t.id === item.id) && 
//       item.published
//   );
  
//   setSubcategories(uniqueSubcategories);
// }, [allCategories, categoryId]);

// Inside ProductsBySubCategory component
useEffect(() => {
  if (!allCategories.length || !categoryId) return;

  const findSubcategories = (categories, parentId) => {
    for (const category of categories) {
      if (category.id === parentId) {
        // Return the direct subcategories with their nested structure
        return category.subcategories
          .filter(subcat => subcat.published)
          .map(subcat => ({
            ...subcat,
            subcategories: findSubcategories([subcat], subcat.id)
          }));
      }
      
      if (category.subcategories?.length > 0) {
        const found = findSubcategories(category.subcategories, parentId);
        if (found.length) return found;
      }
    }
    return [];
  };

  const hierarchicalSubcategories = findSubcategories(allCategories, categoryId);
  setSubcategories(hierarchicalSubcategories);
}, [allCategories, categoryId]);

  // Fetch products and cart data
  useEffect(() => {
    if (token) {
      dispatch(fetchWishlist());
      dispatch(fetchCart());
    }
  }, [token, dispatch]);

  // Fetch products from API when category or subcategory changes
  useEffect(() => {
    if (!selectedSubcategory) return;
    
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/seller/product/get-by-category/${selectedSubcategory}`
        );
        
        // Filter products based on published status at multiple levels
        const list = res.data.products
          .filter((p) => 
            p.published && 
            p.adminPublished && 
            p.brand?.published && 
            p.brand?.adminPublished && 
            p.category?.published
          )
          .map((p) => {
            const activeVar = p.variants?.find((v) => v.status === "active");
            const outOfStockVar = p.variants?.find(v => v.status === "out_of_stock");
            const displayVariant = activeVar || outOfStockVar;
            
            if (!displayVariant) return null;
            
            return {
              ...p,
              variants: [displayVariant],
              isInStock: displayVariant.status === "active" && 
                        (displayVariant.stock > 0 || displayVariant.stock === undefined)
            };
          })
          .filter(Boolean);
          
        setProducts(list);
        setFilteredProducts(list);
        setCategory(
          res.data.products[0]?.category?.name ||
            res.data.products[0]?.subcategory?.name ||
            "Products"
        );
      } catch (e) {
        globalLogout(e)
        if (e.response?.status !== 404) {
        toast.error("Failed to load products");
      }
        setProducts([]);
        setFilteredProducts([]);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [selectedSubcategory]);

  // Handle subcategory selection
  const handleSubcategorySelect = (subcategoryId) => {
    setSelectedSubcategory(subcategoryId);
    setCurrentPage(1);
  };

  // Build filter option data
  const brands = useMemo(() => getUnique(products, "brand"), [products]);
  const prices = useMemo(() => getUnique(products, "price"), [products]);
  const priceRanges = useMemo(() => getPriceRanges(prices), [prices]);
  const ratings = useMemo(
    () => [5, 4, 3, 2, 1].filter((r) => getUnique(products, "ratings").includes(r)),
    [products]
  );

  // Filter logic
  const onFilter = (filters) => {
    let output = [...products];
    if (filters.brands?.length) {
      output = output.filter((p) => filters.brands.includes(p.brand?.name));
    }
    if (filters.price) {
      output = output.filter((p) =>
        p.variants.some(
          (v) => v.price >= filters.price.min && v.price <= filters.price.max
        )
      );
    }
    if (filters.rating) {
      output = output.filter(
        (p) => Math.floor(p.averageRating || 0) >= filters.rating
      );
    }
    setFilteredProducts(output);
    setCurrentPage(1);
  };

  // Reset filter logic
  const onReset = () => {
    setFilteredProducts(products);
    setCurrentPage(1);
  };

  // Sorting
  const sortedProducts = useMemo(() => {
    const sorted = [...filteredProducts];
    switch (sortOption) {
      case "price-low":
        return sorted.sort(
          (a, b) =>
            Math.min(...a.variants.map((v) => v.price)) -
            Math.min(...b.variants.map((v) => v.price))
        );
      case "price-high":
        return sorted.sort(
          (a, b) =>
            Math.max(...b.variants.map((v) => v.price)) -
            Math.max(...a.variants.map((v) => v.price))
        );
      case "rating":
        return sorted.sort((a, b) => (b.averageRating || 0) - (a.averageRating || 0));
      case "newest":
        return sorted.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
      default:
        return sorted;
    }
  }, [filteredProducts, sortOption]);

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedProducts.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
  
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };
  
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };
  
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };
  
  const handleItemsPerPageChange = (e) => {
    const value = parseInt(e.target.value);
    setItemsPerPage(value);
    setCurrentPage(1);
  };

  // Image handling
  const handleImageError = (productId) => {
    setImageErrors(prev => ({
      ...prev,
      [productId]: true
    }));
  };
  
  const getProductImage = (product) => {
    if (imageErrors[product._id]) {
      return fallbackImage;
    }
    return product.variants?.[0]?.images?.[0] || product.images?.[0] || fallbackImage;
  };

  // Cart functionality
  const handleAddToCart = async (product, e) => {
    e.stopPropagation();
    
    if (!token) {
      setProductToAdd(product);
      setShowLoginModal(true);
      return;
    }
    const firstVariantId = product.variants?.[0]?._id;
    
    if (!product.isInStock) {
      toast.warning("This item is out of stock");
      return;
    }
    
    try {
      setLoadingCartItems(prev => ({ ...prev, [product._id]: true }));
      await dispatch(addToCart({
        productId: product._id,
        variantId: product.variants?.length > 0 ? firstVariantId : undefined,
        quantity: 1
      }));
    } catch (error) {
      console.error("Add to cart failed:", error);
      toast.error(error.response?.data?.message || "Failed to add to cart");
    } finally {
      setLoadingCartItems(prev => ({ ...prev, [product._id]: false }));
    }
  };
  
  const confirmAddToCart = async () => {
    setShowLoginModal(false);
    navigate('/login', { state: { from: window.location.pathname } });
  };
  
  const handleQuantityChange = async (productId, newQuantity, e) => {
    e.stopPropagation();
    const product = products.find(p => p._id === productId);
    const firstVariantId = product?.variants?.[0]?._id;
    
    try {
      setLoadingCartItems(prev => ({ ...prev, [productId]: true }));
      await dispatch(updateItemQuantity({ 
        productId, 
        variantId: product?.variants?.length > 0 ? firstVariantId : undefined,
        quantity: newQuantity 
      }));
    } catch (error) {
      console.error("Error updating quantity:", error);
      toast.error("Failed to update quantity. Please try again.");
    } finally {
      setLoadingCartItems(prev => ({ ...prev, [productId]: false }));
    }
  };

  // Wishlist functionality with enhanced animation
  const toggleWishlist = async (productId, variantId, e) => {
    e.stopPropagation();
    if (!token) {
      toast.info("Please login to manage your wishlist");
      navigate('/login');
      return;
    }
    try {
      setLoadingWishlistItems(prev => ({ ...prev, [productId]: true }));
      
      const isInWishlist = wishlist.some(item => 
        item?.productId?._id === productId && 
        item?.variantId === variantId
      );
      
      // Trigger animation
      setWishlistAnimation({
        productId,
        isAdding: !isInWishlist
      });
      
      // Remove animation after 1.5 seconds
      setTimeout(() => {
        setWishlistAnimation(null);
      }, 1500);
      
      if (isInWishlist) {
        await dispatch(removeItemFromWishlist(productId, variantId));
      } else {
        await dispatch(addItemToWishlist(productId, variantId));
      }
    } catch (error) {
      console.error("Wishlist operation failed:", error);
    } finally {
      setLoadingWishlistItems(prev => ({ ...prev, [productId]: false }));
    }
  };

  // Rating stars
  const renderRatingStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    
    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <motion.span 
          key={`full-${i}`}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: i * 0.1 }}
        >
          <BsStarFill className="text-yellow-400" />
        </motion.span>
      );
    }
    
    if (hasHalfStar) {
      stars.push(
        <motion.span 
          key="half"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: fullStars * 0.1 }}
        >
          <BsStarHalf className="text-yellow-400" />
        </motion.span>
      );
    }
    
    const emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <motion.span 
          key={`empty-${i}`}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: (fullStars + (hasHalfStar ? 1 : 0) + i) * 0.1 }}
        >
          <BsStar className="text-yellow-400" />
        </motion.span>
      );
    }
    
    return stars;
  };

  const renderProductActions = (product) => {
    const firstVariant = product.variants?.[0];
    const isLoading = loadingCartItems[product._id];
    
    if (!product.isInStock) {
      return (
        <motion.button 
          className="w-full py-2 px-4 rounded-md bg-gray-300 text-gray-600 cursor-not-allowed mt-4"
          disabled
          whileHover={{ scale: 1.02 }}
        >
          Out of Stock
        </motion.button>
      );
    }
    
    const cartItem = cartItems.find(item => 
      item.productId === product._id && 
      (product.variants?.length > 0 ? item.variantId === firstVariant?._id : true)
    );
    
    if (cartItem) {
      return (
        <motion.div 
          className="flex items-center justify-center space-x-2 mt-4" 
          onClick={(e) => e.stopPropagation()}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <motion.button
            className={`w-8 h-8 flex items-center justify-center rounded-full bg-gradient-to-b from-gray-100 to-gray-200 hover:from-gray-200 hover:to-gray-300 text-gray-700 hover:text-gray-900 hover:shadow-md transition-all duration-200 shadow-sm ${
              isLoading ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            onClick={(e) => {
              e.stopPropagation();
              if (!isLoading) {
                const newQuantity = cartItem.quantity - 1;
                if (newQuantity >= 0) {
                  handleQuantityChange(product._id, newQuantity, e);
                }
              }
            }}
            disabled={isLoading}
            whileTap={{ scale: 0.95 }}
          >
            <span className="text-lg font-medium">−</span>
          </motion.button>
          
          <motion.span 
            className="w-8 text-center font-medium text-gray-700"
            key={cartItem.quantity}
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 500 }}
          >
            {isLoading ? (
              <PulseLoader size={6} color="#6B7280" />
            ) : (
              cartItem.quantity
            )}
          </motion.span>
          
          <motion.button
            className={`w-8 h-8 flex items-center justify-center rounded-full bg-gradient-to-b from-blue-100 to-blue-200 hover:from-blue-200 hover:to-blue-300 text-blue-700 hover:text-blue-900 hover:shadow-md transition-all duration-200 shadow-sm ${
              !product.isInStock || isLoading ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            onClick={(e) => {
              e.stopPropagation();
              if (!isLoading && product.isInStock) {
                handleQuantityChange(product._id, cartItem.quantity + 1, e);
              }
            }}
            disabled={!product.isInStock || isLoading}
            whileTap={{ scale: 0.95 }}
          >
            <span className="text-lg font-medium">+</span>
          </motion.button>
        </motion.div>
      );
    } else {
      return (
        <motion.button 
          className={`w-full py-2 px-4 rounded-md bg-gradient-to-b from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white hover:shadow-md transition-all duration-200 shadow-sm flex items-center justify-center mt-4 ${
            !product.isInStock || isLoading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
          onClick={(e) => {
            e.stopPropagation();
            if (!isLoading && product.isInStock) {
              handleAddToCart(product, e);
            }
          }}
          disabled={!product.isInStock || isLoading}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {isLoading ? (
            <PulseLoader size={8} color="#ffffff" />
          ) : (
            <>
              <AiOutlineShoppingCart className="mr-2" />
              Add to Cart
            </>
          )}
        </motion.button>
      );
    }
  };

  // Pagination controls
  const renderPagination = () => {
    if (totalPages <= 1) return null;
    
    const pages = [];
    const maxVisiblePages = 5;
    
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, currentPage + 2);
    
    if (currentPage <= 3) {
      endPage = Math.min(5, totalPages);
    } else if (currentPage >= totalPages - 2) {
      startPage = Math.max(totalPages - 4, 1);
    }
    
    if (startPage > 1) {
      pages.push(
        <motion.button
          key={1}
          onClick={() => goToPage(1)}
          className={`px-3 py-1 rounded-md ${currentPage === 1 ? 'bg-blue-600 text-white' : 'bg-gray-200 hover:bg-gray-300'}`}
          whileHover={{ y: -2 }}
          whileTap={{ scale: 0.95 }}
        >
          1
        </motion.button>
      );
      if (startPage > 2) {
        pages.push(<span key="ellipsis-start" className="px-2">...</span>);
      }
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <motion.button
          key={i}
          onClick={() => goToPage(i)}
          className={`px-3 py-1 rounded-md ${currentPage === i ? 'bg-blue-600 text-white' : 'bg-gray-200 hover:bg-gray-300'}`}
          whileHover={{ y: -2 }}
          whileTap={{ scale: 0.95 }}
        >
          {i}
        </motion.button>
      );
    }
    
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(<span key="ellipsis-end" className="px-2">...</span>);
      }
      pages.push(
        <motion.button
          key={totalPages}
          onClick={() => goToPage(totalPages)}
          className={`px-3 py-1 rounded-md ${currentPage === totalPages ? 'bg-blue-600 text-white' : 'bg-gray-200 hover:bg-gray-300'}`}
          whileHover={{ y: -2 }}
          whileTap={{ scale: 0.95 }}
        >
          {totalPages}
        </motion.button>
      );
    }
    
    return (
      <motion.div 
        className="flex flex-col sm:flex-row items-center justify-between mt-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="mb-4 sm:mb-0">
          <span className="text-sm text-gray-700">
            Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredProducts.length)} of {filteredProducts.length} products
          </span>
        </div>
        
        <div className="flex items-center space-x-2">
          <motion.select 
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
            className="border rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
            whileHover={{ scale: 1.02 }}
          >
            <option value="8">8 per page</option>
            <option value="12">12 per page</option>
            <option value="16">16 per page</option>
            <option value="20">20 per page</option>
            <option value="24">24 per page</option>
          </motion.select>
          
          <motion.button
            onClick={prevPage}
            disabled={currentPage === 1}
            className={`p-2 rounded-md ${currentPage === 1 ? 'bg-gray-200 cursor-not-allowed' : 'bg-gray-200 hover:bg-gray-300'}`}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FiChevronLeft />
          </motion.button>
          
          <div className="flex space-x-1">
            {pages}
          </div>
          
          <motion.button
            onClick={nextPage}
            disabled={currentPage === totalPages}
            className={`p-2 rounded-md ${currentPage === totalPages ? 'bg-gray-200 cursor-not-allowed' : 'bg-gray-200 hover:bg-gray-300'}`}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <FiChevronRight />
          </motion.button>
        </div>
      </motion.div>
    );
  };

  if (loading) {
    return (
      <motion.div 
        className="min-h-screen flex items-center justify-center bg-gray-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <PulseLoader color="#3B82F6" size={15} />
      </motion.div>
    );
  }

  return (
    <>
      <Header />
      <ProductsLayout
        products={products}
        filters={{ brands, priceRanges, ratings }}
        onFilter={onFilter}
        onReset={onReset}
        subcategories={subcategories}
        onSubcategorySelect={handleSubcategorySelect}
        selectedSubcategory={selectedSubcategory}
      >
        <AnimatePresence>
          {showLoginModal && (
            <motion.div 
              className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
              variants={backdropVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
            >
              <motion.div 
                className="bg-white rounded-lg p-6 max-w-md w-full"
                variants={modalVariants}
              >
                <h3 className="text-lg font-medium text-gray-900 mb-4">Login Required</h3>
                <p className="text-gray-600 mb-6">
                  You need to login to add items to your cart. Would you like to login now?
                </p>
                <div className="flex justify-end space-x-4">
                  <motion.button
                    onClick={() => setShowLoginModal(false)}
                    className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                  >
                    Cancel
                  </motion.button>
                  <motion.button
                    onClick={confirmAddToCart}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                  >
                    Login
                  </motion.button>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
        
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
          <motion.div
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-2xl font-bold text-gray-900">{category}</h1>
            <p className="text-sm text-gray-600 mt-1">
              {filteredProducts.length} {filteredProducts.length === 1 ? 'item' : 'items'}
            </p>
          </motion.div>
          
          <motion.div 
            className="flex items-center gap-2"
            initial={{ x: 20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <span className="text-sm text-gray-600 hidden sm:block">Sort by:</span>
            <motion.select
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
              className="border rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
              whileHover={{ scale: 1.02 }}
            >
              <option value="featured">Featured</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
              <option value="rating">Top Rated</option>
              <option value="newest">Newest Arrivals</option>
            </motion.select>
          </motion.div>
        </div>
        
        {filteredProducts.length === 0 ? (
          <motion.div 
            className="text-center py-16 bg-white rounded-lg shadow-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <div className="mx-auto h-24 w-24 text-gray-400 flex items-center justify-center">
              <AiOutlineHeart className="h-full w-full" />
            </div>
            <h3 className="mt-4 text-lg font-medium text-gray-900">No products found</h3>
            <p className="mt-2 text-sm text-gray-500">
              There are currently no products matching your filters
            </p>
            <div className="mt-6">
              <motion.button 
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700" 
                onClick={onReset}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Reset Filters
              </motion.button>
            </div>
          </motion.div>
        ) : (
          <>
            <motion.div 
              className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              {currentItems.map((product) => {
                const productImage = getProductImage(product);
                const firstVariantId = product.variants?.[0]?._id;
                const isInWishlist = wishlist.some(item => 
                  item?.productId?._id === product?._id && 
                  item?.variantId === firstVariantId
                );
                
                // Check if this product is currently animating
                const isAnimating = wishlistAnimation?.productId === product._id;
                const isAdding = wishlistAnimation?.isAdding;
                
                return (
                  <motion.div 
                    key={product._id}
                    className={`bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 cursor-pointer flex flex-col h-full ${
                      !product.isInStock ? 'opacity-80' : ''
                    }`}
                    onClick={() => navigate(`/product/${product._id}`)}
                    variants={itemVariants}
                    whileHover="hover"
                  >
                    <div className="relative aspect-square bg-gray-100">
                      <motion.img
                        src={productImage}
                        alt={product.name}
                        className="w-full h-full object-cover"
                        onError={() => handleImageError(product._id)}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.5 }}
                      />
                      {!product.isInStock && (
                        <div className="absolute inset-0 bg-white bg-opacity-60 flex items-center justify-center">
                          <span className="bg-gray-800 text-white px-3 py-1 rounded-md text-sm font-medium">
                            Out of Stock
                          </span>
                        </div>
                      )}
                      {token && (
                        <div className="absolute top-2 right-2">
                          <motion.button
                            onClick={(e) => toggleWishlist(product._id, firstVariantId, e)}
                            disabled={loadingWishlistItems[product._id]}
                            className={`relative p-2 rounded-full bg-white bg-opacity-80 hover:bg-opacity-100 transition-all duration-200 shadow-sm z-10 ${
                              isAnimating ? (isAdding ? 'text-red-500' : 'text-gray-500') : ''
                            }`}
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            {loadingWishlistItems[product._id] ? (
                              <div className="h-5 w-5 flex items-center justify-center">
                                <PulseLoader size={6} color="#EF4444" />
                              </div>
                            ) : (
                              <motion.div 
                                variants={heartBeatVariants}
                                initial="initial"
                                animate={isAnimating ? "animate" : "initial"}
                              >
                                {isInWishlist ? (
                                  <AiFillHeart className="h-5 w-5 text-red-500 hover:text-red-700" />
                                ) : (
                                  <AiOutlineHeart className="h-5 w-5 text-gray-500 hover:text-gray-700" />
                                )}
                              </motion.div>
                            )}
                          </motion.button>
                        </div>
                      )}
                      {product.promotion && (
                        <motion.div 
                          className="absolute top-2 left-2 bg-yellow-100 text-yellow-800 text-xs font-semibold px-2 py-1 rounded-full flex items-center"
                          initial={{ scale: 0 }}
                          animate={{ scale: 1 }}
                          transition={{ delay: 0.2 }}
                        >
                          <BsStars className="mr-1" />
                          <span>Deal</span>
                        </motion.div>
                      )}
                    </div>
                    <div className="p-4 flex flex-col flex-grow">
                      <h3 className="text-lg font-semibold text-gray-800 mb-1 truncate">
                        {product.name}
                      </h3>
                      <p className="text-gray-600 text-sm mb-2 line-clamp-2 min-h-[2.5rem]">
                        {product.description || 'No description available'}
                      </p>
                      
                      <div className="flex items-center mb-2">
                        <div className="flex mr-1">
                          {renderRatingStars(product.averageRating || 0)}
                        </div>
                        <span className="text-xs text-gray-500">
                          ({product.reviewCount || 0})
                        </span>
                      </div>
                      
                      <div className="flex justify-between items-center mt-auto">
                        <motion.span 
                          className="text-lg font-bold text-blue-600"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          transition={{ delay: 0.2 }}
                        >
                          ₹{product.variants?.[0]?.price?.toFixed(2) || '0.00'}
                        </motion.span>
                        <motion.span 
                          className={`text-xs px-2 py-1 rounded-full ${
                            product.isInStock ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                          }`}
                          initial={{ scale: 0 }}
                          animate={{ scale: 1 }}
                          transition={{ delay: 0.3 }}
                        >
                          {product.isInStock ? 'In Stock' : 'Out of Stock'}
                        </motion.span>
                      </div>
                      
                      <div className="mt-4">
                        {renderProductActions(product)}
                      </div>
                    </div>
                  </motion.div>
                );
              })}
            </motion.div>
            {renderPagination()}
          </>
        )}
      </ProductsLayout>
      <Footer />
    </>
  );
};

export default ProductsBySubCategory;